/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class OperationTypeField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const options = [{ key: 1, text: 'No', value: false }, { key: 2, text: 'Yes', value: true }]

    return (
      <Form.Select
        required
        fluid
        label="Monthly Report"
        options={options}
        placeholder="Is this Store collecting payment at the end of the month?"
        onChange={(e, data) => onChange('monthly_report', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/monthlyReportField.js